import { render, staticRenderFns } from "./EventSetupBasic.vue?vue&type=template&id=e919d768"
import script from "./EventSetupBasic.vue?vue&type=script&lang=js"
export * from "./EventSetupBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports